import { CompleteLicense } from '@/interfaces/dashboard/licenses';
import { Document } from '@/interfaces/requirement';
import { RequirementService } from '@/services/requirement/requirement.service';
import { StoreState } from '@/store';
import { State } from '@/store/login/reducer';
import { getCurrentUserData } from '@/store/login/selectors';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { normalize } from '@/utils/normalizeString';
@Component({
  selector: 'app-documents-validity',
  templateUrl: './documents-validity.component.html',
  styleUrls: ['./documents-validity.component.css'],
})
export class DocumentsValidityComponent implements OnInit {

  @Input() licenseData: Partial<CompleteLicense> = {};
  @Output() returnToLicenses = new EventEmitter<boolean>();

  driverIsEmployee: boolean = false;

  documents: Document[] = [];
  validityView: boolean = true
  userData: Partial<State> = {};

  constructor(
    private store: Store<StoreState>,
    private requirementService: RequirementService,
  ) {
    getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.userData = userData;
        this.driverIsEmployee = normalize(userData?.entity) === normalize('Employee');
      },
    });
  }

  ngOnInit(): void {
    this.getDocuments();
  }

  onReturnToLicenses() {
    this.returnToLicenses.emit(false);
  }

  getDocuments() {
    const { requirementId } = this.licenseData;
    if (requirementId) {
      this.requirementService.getDetails(requirementId).subscribe({
        next: (data) => {
          this.documents = data.documents;
        },
      });

    }
  }

}
